import { IGroupBySubscriptionServiceInvoice, IUsage } from "app/store/BillingUsage/BillingUsage.models";

export default function useGroupBySubscriptionServiceInvoice(usages: IUsage[], includedInvoiceStatuses?: string[]): IGroupBySubscriptionServiceInvoice[] {
  const grouped: Record<string, IGroupBySubscriptionServiceInvoice> = {};

  usages.forEach(usage => {
    const subscriptionId = usage.subscription?.id ?? "unknown-sub";
    const subscriptionName = usage.subscription?.name ?? "Unknown Subscription";
    const serviceId = usage.service?.id ?? "unknown-srv";
    const serviceName = usage.service?.name ?? "Unknown Service";
    const invoices = usage.invoices ?? [];
    const quantity = usage.quantity ?? 0;
    const amount = usage.amount ?? 0;

    // Ensure subscription exists
    if (!grouped[subscriptionId]) {
      grouped[subscriptionId] = {
        id: subscriptionId,
        name: subscriptionName,
        services: []
      };
    }

    // Ensure service exists under subscription
    let serviceGroup = grouped[subscriptionId].services.find(s => s.id === serviceId);
    if (!serviceGroup) {
      serviceGroup = {
        id: serviceId,
        name: serviceName,
        quantity: 0,
        amount: 0,
        invoices: []
      };
      grouped[subscriptionId].services.push(serviceGroup);
    }

    // Add totals
    serviceGroup.quantity += quantity;
    serviceGroup.amount += amount;

    // Ensure invoices are unique
    invoices.forEach(invoice => {
      const existingInvoice = serviceGroup!.invoices.find(inv => inv.id === invoice.id);
      const isInvoiceStatusIncluded = !includedInvoiceStatuses || includedInvoiceStatuses.includes(invoice.status);
      if (!existingInvoice && isInvoiceStatusIncluded) serviceGroup!.invoices.push(invoice);
    });
  });

  // Convert to array and sort by total amount descending
  return Object.values(grouped)
    .map(sub => ({
      ...sub,
      totalAmount: sub.services.reduce((sum, s) => sum + s.amount, 0),
    }))
    .sort((a, b) => b.totalAmount - a.totalAmount)
    .map(({ totalAmount, ...sub }) => sub);
}